import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";


import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";

import Popup01 from "../../pages/popup/Popup01"
import PopupPlanModel from "../../pages/popup/PopupPlanModel"
import ModelOptionCard from "../../components/ModelOptionCard"

import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';



import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

export default function BuyList() {
    const location = useLocation();
    
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { mbData } = useSelector((s) => s.usersReducer);

    const fileRef = useRef();

    const [detailView1, setDetailView1] = useState(false);
    const [detailView2, setDetailView2] = useState(false);
    const [detailView3, setDetailView3] = useState(false);
    const [detailView4, setDetailView4] = useState(false);

    const lang = useSelector(state => state.langReducer.lang);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
    useEffect(() => {
        if(!mbData?.idx) {
            navigate(routes.main);
        }
    }, []);

    const UseCoupon = (type) => {
        if(type === "no_member") {
            dispatch(open({
                component: 
                    <PopupPlanModel 
                        max_width={'480px'}
                        plan_type={'Pro'}
                        longButton={lang === 0 ? '쿠폰 사용' : 'Use Coupon'}
                        useCoupon={true}
                    />
            }));
        }

        if(type === "member") {
            dispatch(open({
                component: 
                    <PopupPlanModel 
                        max_width={'480px'}
                        plan_type={'Classroom'}
                        longButton={lang === 0 ? '쿠폰 사용' : 'Use Coupon'}
                        useCoupon={true}
                        member={true}
                    />
            }));
        }
    }

    const PlusPop = (type) => {
        if(type === "license") {
            dispatch(open({
                component: 
                    <PopupPlanModel 
                        max_width={'480px'}
                        plan_type={'Team'}
                        longButton={lang === 0 ? '결제하기' : 'Pay Now'}
                        pay_card={true}
                        plan_plus={true}
                    />
            }));
        }
    }
    
    return (
        <>
            <div className="main_back">
                <div className="main_part profile padding">
                    <div className="profile_edit_box">
                        <div 
                            className="title_box"
                            onClick={() => {
                                navigate(-1);
                            }}
                        >
                            <img src={require("../../assets/icon/back_arr.svg").default}/>
                            
                            <p>{lang === 0 ? '구매 내역' : 'Purchase History'}</p>
                        </div>

                        <div className="buy_list_box">
                            <div className="my_buy_plan">
                                <div className="title_box">
                                    <div className="title">
                                        <p>UModeler X PRO</p>
                                        <span
                                            onClick={() =>{
                                                UseCoupon("no_member")
                                            }}
                                        >
                                            {lang === 0 ? '사용 가능한 쿠폰이 있습니다.' : 'You have available coupons.'}<br /> 
                                            {lang === 0 ? '쿠폰을 사용하여 요금을 절감하세요' : 'Use them to save on your bill.'}
                                        </span>
                                    </div>

                                    <button
                                        type="button"
                                    >   
                                        <img src={require("../../assets/icon/down.svg").default}/>
                                        <span>{lang === 0 ? '다운로드' : 'Download'}</span>
                                    </button>
                                </div>

                                <div className="content_box">
                                    <div className="info_box">
                                        <div className="info">
                                            <p className="title">{lang === 0 ? '청구 옵션' : 'Billing Option'}</p>
                                            <span>{lang === 0 ? '월간 결제' : 'Monthly Billing'}</span>
                                        </div>

                                        <div className="info">
                                            <p className="title">{lang === 0 ? '구독 시작일' : 'Subscription Start Date'}</p>
                                            <span>2024-06-07</span>
                                        </div>

                                        <div className="info">
                                            <p className="title">{lang === 0 ? '다음 결제일' : 'Next Billing Date'}</p>
                                            <span>2024-07-07</span>
                                            <p 
                                                className="cancel pc"
                                                onClick={() => {
                                                    navigate(routes.CancelSub)
                                                }}
                                            >
                                                {lang === 0 ? '구독 해지' : 'Cancel Subscription'}
                                            </p>
                                        </div>
                                    </div>

                                    <button
                                        type="button"
                                    >
                                        <img src={require("../../assets/icon/search_blue.svg").default}/>
                                        <span>{lang === 0 ? '청구 내역 보기' : 'View Billing Details'}</span>
                                    </button>
                                </div>
                            </div>

                            <div className="my_buy_plan off">
                                <div className="title_box">
                                    <div className="title">
                                        <p>UModeler X Pro</p>
                                    </div>

                                    <button
                                        type="button"
                                    >   
                                        <img src={require("../../assets/icon/down.svg").default}/>
                                        <span>{lang === 0 ? '다운로드' : 'Download'}</span>
                                    </button>
                                </div>

                                <div className="content_box">
                                    <div className="info_box">
                                        <div className="info">
                                            <p className="title">{lang === 0 ? '청구 옵션' : 'Billing Option'}</p>
                                            <span>{lang === 0 ? '월간 결제' : 'Monthly Billing'}</span>
                                        </div>

                                        <div className="info">
                                            <p className="title">{lang === 0 ? '구독 시작일' : 'Subscription Start Date'}</p>
                                            <span>2024-06-07</span>
                                        </div>

                                        <div className="info">
                                            <p className="title">{lang === 0 ? '다음 결제일' : 'Next Billing Date'}</p>
                                            <p className="cancel on">{lang === 0 ? '해지 완료' : 'Cancelled'}</p>
                                        </div>
                                    </div>

                                    <button
                                        type="button"
                                    >
                                        <img src={require("../../assets/icon/search_blue.svg").default}/>
                                        <span>{lang === 0 ? '청구 내역 보기' : 'View Billing Details'}</span>
                                    </button>
                                </div>
                            </div>

                            <div className="my_buy_plan">
                                <div className="title_box">
                                    <div className="title">
                                        <p>UModeler X PRO</p>
                                    </div>

                                    <button
                                        type="button"
                                    >   
                                        <img src={require("../../assets/icon/down.svg").default}/>
                                        <span>{lang === 0 ? '다운로드' : 'Download'}</span>
                                    </button>
                                </div>

                                <div className="content_box">
                                    <div className="info_box">
                                        <div className="info">
                                            <p className="title">{lang === 0 ? '청구 옵션' : 'Billing Option'}</p>
                                            <span>{lang === 0 ? '월간 결제' : 'Monthly Billing'}</span>
                                        </div>

                                        <div className="info">
                                            <p className="title">{lang === 0 ? '무료 이용기간' : 'Free Trial Period'}</p>
                                            <span className="free">{lang === 0 ? '14일간 무료 (4일 남음)' : 'Free for 14 days (4 days left)'}</span>
                                            <p 
                                                className="cancel"
                                                onClick={() => {
                                                    navigate(routes.CancelSub)
                                                }}
                                            >
                                                {lang === 0 ? '구독 해지' : 'Cancel Subscription'}
                                            </p>
                                        </div>

                                        <div className="info">
                                            <p className="title">{lang === 0 ? '구독 시작일' : 'Subscription Start Date'}</p>
                                            <span>2024-06-07</span>
                                        </div>

                                        <div className="info">
                                            <p className="title">{lang === 0 ? '다음 결제일' : 'Next Billing Date'}</p>
                                            <span>2024-07-07</span>
                                        </div>
                                    </div>

                                    <button
                                        type="button"
                                    >
                                        <img src={require("../../assets/icon/search_blue.svg").default}/>
                                        <span>{lang === 0 ? '청구 내역 보기' : 'View Billing Details'}</span>
                                    </button>
                                </div>
                            </div>

                            <div className="my_buy_plan"> {/* Team과 Classroom은 멤버 수 표기 */}
                                <div className="title_box">
                                    <div className="title">
                                        <p>UModeler X Classroom</p>
                                        <span
                                            onClick={() =>{
                                                UseCoupon("member")
                                            }}
                                        >
                                            {lang === 0 ? '사용 가능한 쿠폰이 있습니다.' : 'You have available coupons.'}<br /> 
                                            {lang === 0 ? '쿠폰을 사용하여 요금을 절감하세요' : 'Use them to save on your bill.'}
                                        </span>
                                    </div>

                                    <button
                                        type="button"
                                    >   
                                        <img src={require("../../assets/icon/down.svg").default}/>
                                        <span>{lang === 0 ? '다운로드' : 'Download'}</span>
                                    </button>
                                </div>

                                <div className="content_box team">
                                    <div className="info_box">
                                        <div className="info">
                                            <p className="title">{lang === 0 ? '청구 옵션' : 'Billing Option'}</p>
                                            <span>{lang === 0 ? '월간 결제' : 'Monthly Billing'}</span>
                                        </div>

                                        <div className="info">
                                            <p className="title">{lang === 0 ? '멤버' : 'Members'}</p>
                                            <span>8</span>
                                        </div>

                                        <div className="info">
                                            <p className="title">{lang === 0 ? '구독 시작일' : 'Subscription Start Date'}</p>
                                            <span>2024-06-07</span>
                                            <p 
                                                className="cancel"
                                                onClick={() => {
                                                    navigate(routes.CancelSub)
                                                }}
                                            >
                                                {lang === 0 ? '구독 해지' : 'Cancel Subscription'}
                                            </p>
                                        </div>

                                        <div className="info">
                                            <p className="title">{lang === 0 ? '다음 결제일' : 'Next Billing Date'}</p>
                                            <span>2024-07-07</span>
                                        </div>
                                    </div>

                                    <div className="plus_box team_pc">
                                        <div 
                                            className="btn_box"
                                            onClick={() => {
                                                PlusPop("license")
                                            }}
                                        >
                                            <div className="img_box">
                                                <img src={require("../../assets/icon/plus_plan.svg").default}/>
                                            </div>

                                            <p>{lang === 0 ? '라이선스' : 'License'}<br />{lang === 0 ? '추가 구매' : 'Additional Purchase'}</p>
                                        </div>

                                        <div 
                                            className="btn_box"
                                            onClick={() => {
                                                navigate(routes.PlusMember)
                                            }}
                                        >
                                            <div className="img_box">
                                                <img src={require("../../assets/icon/plus_member.svg").default}/>
                                            </div>

                                            <p>{lang === 0 ? '멤버' : 'Member'}<br />{lang === 0 ? '추가' : 'Add'}</p>
                                        </div>

                                        <div 
                                            className="btn_box"
                                            onClick={() => {
                                                navigate(routes.PlusAdmin)
                                            }}
                                        >
                                            <div className="img_box">
                                                <img src={require("../../assets/icon/plus_admin.svg").default}/>
                                            </div>

                                            <p>{lang === 0 ? '관리자' : 'Admin'}<br />{lang === 0 ? '추가' : 'Add'}</p>
                                        </div>
                                    </div>

                                    <button
                                        type="button"
                                        className="team_pc"
                                    >
                                        <img src={require("../../assets/icon/search_blue.svg").default}/>
                                        <span>{lang === 0 ? '청구 내역 보기' : 'View Billing Details'}</span>
                                    </button>

                                    <div className="team_mobile_box">
                                        <button
                                            type="button"
                                        >
                                            <img src={require("../../assets/icon/search_blue.svg").default}/>
                                            <span>{lang === 0 ? '청구 내역 보기' : 'View Billing Details'}</span>
                                        </button>

                                        <div className="plus_box">
                                            <div 
                                                className="btn_box"
                                                onClick={() => {
                                                    PlusPop("license")
                                                }}
                                            >
                                                <div className="img_box">
                                                    <img src={require("../../assets/icon/plus_plan.svg").default}/>
                                                </div>

                                                <p>{lang === 0 ? '라이선스' : 'License'}<br />{lang === 0 ? '추가 구매' : 'Additional Purchase'}</p>
                                            </div>

                                            <div 
                                                className="btn_box"
                                                onClick={() => {
                                                    navigate(routes.PlusMember)
                                                }}
                                            >
                                                <div className="img_box">
                                                    <img src={require("../../assets/icon/plus_member.svg").default}/>
                                                </div>

                                                <p>{lang === 0 ? '멤버' : 'Member'}<br />{lang === 0 ? '추가' : 'Add'}</p>
                                            </div>

                                            <div 
                                                className="btn_box"
                                                onClick={() => {
                                                    navigate(routes.PlusAdmin)
                                                }}
                                            >
                                                <div className="img_box">
                                                    <img src={require("../../assets/icon/plus_admin.svg").default}/>
                                                </div>

                                                <p>{lang === 0 ? '관리자' : 'Admin'}<br />{lang === 0 ? '추가' : 'Add'}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> {/* 메인 div */}

            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
                hideProgressBar
            />
        </>
    );
}